import { apiRequest } from "@services/apiClient";

// Admin-only per-clinic call flows (emergency, etc.).
// Each flow has separate wording for during opening hours and after hours;
// the backend picks the applicable one when a call comes in.

export const fetchCallFlows = (clinicId) =>
  apiRequest({ method: "GET", endpoint: `/clinic/${clinicId}/call-flows` });

export const saveCallFlow = (clinicId, flowKey, body) =>
  apiRequest({ method: "PUT", endpoint: `/clinic/${clinicId}/call-flows/${flowKey}`, body });

export const deleteCallFlow = (clinicId, flowKey) =>
  apiRequest({ method: "DELETE", endpoint: `/clinic/${clinicId}/call-flows/${flowKey}` });
